import type { ChangeOrderIncident } from './incidents/ChangeOrderIncident.js'
import type { DeleteIncident } from './incidents/DeleteIncident.js'
import type { AddIncident, UpdateIncident } from './incidents/index.js'

export type QueueStatus = 'idle' | 'processing'

export type QueueIncident =
  AddIncident | UpdateIncident | DeleteIncident | ChangeOrderIncident

export type OnChangePayload = {
  queue: QueueIncident[]
  status: QueueStatus
  errorQueueIncidents: QueueIncident[]
  currentError: unknown
  removedUuid?: string // uuid of incident removed from queue (incident won't be processed be queue)
}

export type OnChange = (payload: OnChangePayload) => void

export type ConfirmQueueIncident = (
  uuid: string,
  resolve: () => void,
  reject: (error: Error) => void,
) => void

export type ProcessAllowedQueueIncidentError = (
  error: unknown,
  queueIncident: QueueIncident,
) => Promise<boolean>

export type BeforeQueueIncidentProcessing = (
  queueIncident: QueueIncident,
) => Promise<void> | void

export class IncidentQueueTimeoutError extends Error {}
